import { createFileRoute } from '@tanstack/react-router';

import { TeamMemberNotificationView } from '@apps/web/components/settings/team_member_notification_editor';

export const Route = createFileRoute(
    '/_app/settings/team-members_/$memberUserId/notifications/',
)({ component: TeamMemberNotifications });

function TeamMemberNotifications() {
    const { memberUserId } = Route.useParams();
    return <TeamMemberNotificationView memberUserId={memberUserId} />;
}
